export default {
    common: {
        actions: '操作',
        add: '追加',
        edit: '編集',
        delete: '削除',
        search: '検索',
        reset: 'リセット',
        export: 'エクスポート',
        submit: '確定',
        confirm: '確定',
        cancel: 'キャンセル',
        enable: '有効化',
        disable: '無効化',
        expand: '展開/折りたたみ',
        close: '閉じる',
        startDate: '開始日',
        endDate: '終了日',
        to: 'から'
    },
    route: {
        dashboard: '管理システム',
        usermanger:'ユーザーセンター',
        introduction: '概要',
        documentation: 'ドキュメント',
        permission: '権限テストページ',
        pagePermission: 'ページ権限',
        directivePermission: 'ディレクティブ権限',
        icons: 'アイコン',
        components: 'コンポーネント',
        componentIndex: '紹介',
        tinymce: 'リッチテキストエディタ',
        markdown: 'Markdown',
        jsonEditor: 'JSONエディタ',
        dndList: 'リストドラッグ',
        splitPane: 'スプリットペイン',
        avatarUpload: 'アバターアップロード',
        dropzone: 'ドロップゾーン',
        sticky: 'スティッキー',
        countTo: 'カウントTo',
        componentMixin: '小コンポーネント',
        backToTop: 'トップへ戻る',
        dragDialog: 'ダイアログドラッグ',
        dragKanban: 'ドラッグ可能なカンバン',
        charts: 'チャート',
        keyboardChart: 'キーボードチャート',
        lineChart: '折れ線グラフ',
        mixChart: '複合グラフ',
        example: '総合例',
        Table: 'テーブル',
        dynamicTable: '動的テーブル',
        dragTable: 'ドラッグテーブル',
        inlineEditTable: 'テーブル内編集',
        complexTable: '複合テーブル',
        treeTable: 'ツリーテーブル',
        customTreeTable: 'カスタムツリーテーブル',
        tab: 'タブ',
        form: 'フォーム',
        createForm: 'フォーム作成',
        editForm: 'フォーム編集',
        errorPages: 'エラーページ',
        page401: '401',
        page404: '404',
        errorLog: 'エラーログ',
        excel: 'Excel',
        exportExcel: 'Excelエクスポート',
        selectExcel: '選択エクスポート',
        uploadExcel: 'Excelアップロード',
        zip: 'Zip',
        exportZip: 'Zipエクスポート',
        theme: 'テーマ',
        clipboardDemo: 'クリップボード',
        i18n: '国際化'
    },
    navbar: {
        logOut: 'ログアウト',
        dashboard: 'ホーム',
        github: 'プロジェクトアドレス',
        screenfull: '全画面',
        theme: 'テーマ',
        projectManagement: 'プロジェクト管理',
        recycleBin: 'リサイクルセンター',
        systemManagement: 'システム管理',
        userManagement: 'ユーザー管理',
        roleManagement: 'ロール管理',
        menuManagement: 'メニュー管理',
        codeGeneration: 'コード生成',
        projectList: 'プロジェクトリスト',
        automatedReport: '自動化レポート',
        favoritesCenter: 'お気に入りセンター',
        collaborativeSurvey: '協働調査',
        pushCenter: 'プッシュセンター',
        systemSettings: 'システム設定'
    },
    login: {
        title: 'システムログイン',
        logIn: 'ログイン',
        username: 'ユーザー名',
         password: 'パスワード',
        any: '適当に入力',
        thirdparty: 'サードパーティー認証',
        thirdpartyTips: 'ローカルではシミュレートできません。ビジネスロジックに合わせてシミュレートしてください！！！'
    },
    loginPage: {
        kickedTitle: '別の場所でログイン',
        kickedDesc: 'アカウントが他のデバイスでログインされたため、このデバイスはログアウトされました。心当たりがない場合は、すぐにパスワードを変更してください。',
        loginTitle: 'ログイン',
        username: 'ユーザー名',
        usernameLogin: 'ユーザー名/携帯番号',
        loginModePassword: 'パスワードログイン',
        loginModeSms: 'SMS認証コードログイン',
        loginModeLabel: 'ログイン方法',
        password: 'パスワード',
        forgotPassword: 'パスワードを忘れましたか？',
        login: 'ログイン',
        orLoginWith: 'またはソーシャルプラットフォームでログイン',
        registerTitle: '登録',
        register: '登録',
        orRegisterWith: 'またはソーシャルプラットフォームで登録',
        hello: 'こんにちは、ようこそ',
        noAccount: 'アカウントがありませんか？',
        toRegister: '登録',
        welcomeBack: 'ようこそ！',
        hasAccount: 'アカウントがありますか？',
        toLogin: 'ログイン',
        usernameRequired: 'ユーザー名を入力してください',
        usernameInvalid: 'ユーザー名には英字を含める必要があります',
        passwordRequired: 'パスワードを入力してください',
        loginSuccess: 'ログイン成功',
    },
    documentation: {
        documentation: 'ドキュメント',
        github: 'Githubアドレス'
    },
    // ===== リアルタイム共同編集（編集側 WebSocket）=====
    collab: {
        online: 'オンラインの共同編集者',
        someone: '共同編集者',
        updated: 'が更新しました',
        isEditing: 'が編集中',
        updatedBadge: '{name} が更新しました',
        loadLatest: '最新を読み込む',
        overwrite: '自分の内容で上書き',
        loadLatestBtn: '相手のバージョンを読み込む',
        conflictTitle: '保存の競合',
        conflictDesc: 'この設問は他の共同編集者によって変更されました。今回の変更は保存されていません。',
        conflictTip: '「自分の内容で上書き」は相手の変更を自分の内容に置き換えます。「相手のバージョンを読み込む」は今回の変更を破棄します。',
        overwriteSuccess: '上書き保存しました',
        overwriteFail: '上書き保存に失敗しました',
        loadedLatest: '相手の最新バージョンを読み込みました',
        reconnecting: 'リアルタイム共同編集が切断されました。再接続中…',
        degraded: 'リアルタイム共同編集は一時的に利用できません（自動再試行中）'
    },
    permission: {
        roles: 'あなたの権限',
        switchRoles: '権限を切り替える'
    },
    components: {
        documentation: 'ドキュメント',
        tinymceTips: 'リッチテキストは管理システムの重要な機能ですが、同時に多くの穴があります。富文本を選択する際にも多くの道を歩みましたが、市場で一般的に使用されている富文本はほとんど試しました。最終的に、Tinymceを選択しました。より詳細な富文本比較と紹介はこちらをご覧ください。',
        dropzoneTips: '私たちの業務には特殊な要件があり、七牛を渡す必要があるため、サードパーティーを使用せず、独自にパッケージ化しました。コードは非常にシンプルで、具体的なコードはここで見ることができます @/components/Dropzone',
        stickyTips: 'ページが予め設定された位置にスクロールすると、トップに吸着します',
        backToTopTips1: 'ページが指定された位置にスクロールすると、右下に戻るボタンが表示されます',
        backToTopTips2: 'ボタンのスタイル、表示/非表示、表示位置、戻る位置をカスタマイズできます。テキストプロンプトが必要な場合は、Elementのel-tooltip要素を外部で使用できます。',
        imageUploadTips: '私が使用している間、それはvue@1バージョンのみで、mockjsと互換性がなく、独自に改造しました。もし皆さんが使用する場合は、優先的に公式バージョンを使用することをお勧めします。'
    },
    table: {
        dynamicTips1: '固定ヘッダー、ヘッダー順に並べ替え',
        dynamicTips2: '固定ヘッダーなし、クリック順に並べ替え',
        dragTips1: 'デフォルト順序',
        dragTips2: 'ドラッグ後の順序',
        title: 'タイトル',
        importance: '重要性',
        type: 'タイプ',
        remark: 'コメント',
        reviewer: 'レビュアー',
        id: '番号',
        date: '日付',
        author: '著者',
        readings: '閲覧数',
        status: 'ステータス',
        publish: '公開',
        draft: '下書き',
    },
    errorLog: {
        tips: '右上隅のバグアイコンをクリックしてください',
        description: '現在の管理システムはほとんどSPA形式です。これはユーザー体験を強化しますが、同時にページの問題が発生する可能性も高くなります。小さなミスでもページ全体がフリーズする可能性があります。幸い、Vue公式は例外をキャプチャして処理する方法を提供しています。そこで、エラー処理またはエラー報告を行うことができます。',
        documentation: 'ドキュメント紹介'
    },
    excel: {
        export: 'エクスポート',
        selectedExport: '選択した項目をエクスポート',
        placeholder: 'ファイル名を入力してください（デフォルト：excel-list）'
    },
    zip: {
        export: 'エクスポート',
        placeholder: 'ファイル名を入力してください（デフォルト：file）'
    },
    theme: {
        change: 'テーマ',
        documentation: 'テーマドキュメント',
        tips: 'ヒント：これはnavbarのtheme-pickとは異なり、2つの異なるテーマ方法です。それぞれに異なる用途があり、詳細についてはドキュメントを参照してください。'
    },
    tagsView: {
        close: '閉じる',
        closeOthers: 'その他を閉じる',
        closeAll: 'すべてを閉じる'
    },
    dashboard: {
        kpi: {
            surveyCount: "アンケート数",
            userCount: "ユーザー数",
            ongoingSurvey: "進行中のアンケート",
            recoveryRate: "アンケート回収率"
        },
        trend: "データトレンド統計",
        client: "クライアント",
        browser: "ブラウザ",
        system: "システム",
        newSurvey: "新しいアンケート",
        announcement: "お知らせ"
    },
    project: {
        collaborator: {
            sharedWithMe: '共有中',
            readonly: '閲覧のみ',
            share: '共有',
            view: '表示',
            sharedFrom: '共有元',
            title: 'プロジェクトを共有',
            tip: '共有メンバーはこのプロジェクトの最新内容（設問、設定、回答、統計）を閲覧できますが、変更はできません。',
            searchPlaceholder: 'アカウントまたは氏名で検索（2文字以上）',
            search: '検索',
            searchResult: '検索結果',
            invite: '招待',
            memberList: '共有メンバー',
            emptyMembers: 'まだ誰とも共有していません',
            emptySearch: '一致するユーザーが見つかりません',
            remove: '削除',
            close: '閉じる',
            readonlyTip: 'このプロジェクトは閲覧のみで共有されています。すべて閲覧できますが、変更はできません。',
            needKeyword: '2文字以上入力してください',
            inviteSuccess: 'このユーザーと共有しました',
            inviteFail: '共有に失敗しました',
            removeSuccess: 'メンバーを削除しました',
            removeFail: '削除に失敗しました',
            sidebarReadonlyTip: '閲覧のみの共有：閲覧は可能ですが変更はできません',
            bannerPrefix: 'このプロジェクトは',
            bannerSuffix: 'さんから共有されています。すべて（回答・統計を含む）閲覧できますが、変更はできません。',
            otherUser: '他のユーザー',
            tip2: '招待されたメンバーは確認後にこのプロジェクトを閲覧できます。確認後は設問・設定・回答・統計を閲覧できますが、変更はできません。',
            inviteSent: '招待を送信しました。相手の確認をお待ちください',
            statusPending: '確認待ち',
            statusAccepted: '参加済み',
            statusRejected: '辞退',
            reinvite: '再招待',
            invitePanelTitle: '新しいプロジェクト共有の招待があります',
            collapse: '折りたたむ',
            expand: '展開',
            invitedBy: '招待元',
            accept: '承認',
            reject: '辞退',
            acceptSuccess: '招待を承認しました。リストに追加されました',
            acceptFail: '承認に失敗しました',
            rejectSuccess: '招待を辞退しました',
            rejectFail: '辞退に失敗しました',
            searchFailed: '検索に失敗しました',
            tip3: 'モジュールごとに権限を設定します：「閲覧のみ」のモジュールは内容を閲覧でき、「編集可能」のモジュールは変更できます。招待相手の確認後に有効になります。未承認のモジュールは相手に表示されません。',
        },
        permission: {
            module: 'モジュール',
            none: '権限なし',
            read: '閲覧のみ',
            write: '編集可能',
            editButton: '権限を変更',
            configTitle: '権限を設定',
            configTitleEdit: '権限を変更',
            save: '保存',
            saveSuccess: '権限を更新しました',
            saveFail: '権限の更新に失敗しました',
            defaultTip: '初期状態はすべて「閲覧のみ」です。必要に応じて各モジュールの権限を調整してから招待を送信してください。',
            pureReadOnlyTip: '「データダウンロード」「統計分析」は閲覧専用モジュールのため、「編集可能」の権限はありません。',
            dataWriteTip: '回答のステータス変更や回答の削除（データページの一括メンテナンスを含む）には「データ」を「編集可能」にしてください。「閲覧のみ」では回答の閲覧だけが可能です。',
            moreItems: 'ほか {n} 件',
            modules: {
                design: 'アンケート編集',
                setting: 'アンケート設定',
                data: 'データ',
                download: 'データダウンロード',
                statistics: '統計分析',
                quota: 'クォータ管理',
                publish: '公開と収集'
            }
        },
        id: "プロジェクトID",
        name: "プロジェクト名",
        status: "ステータス",
        createTime: "作成日時",
        creator: "作成者",
        all: "すべて",
        design: "デザイン中",
        progress: "公開中",
        completed: "完了",
        expireOverlayText: 'プロジェクトの有効期限が切れました。終了または延長してください',
        extendProject: '延長する',
        closeProject: '終了する',
        extendSuccess: '延長しました',
        extendFail: '延長に失敗しました',
        closeSuccess: 'プロジェクトを終了しました',
        closeFail: '終了に失敗しました',
        closeProjectTitle: 'プロジェクト終了',
        closeProjectTip: '終了するとアンケートリンクにアクセスできなくなります。よろしいですか？',
        noData: "データなし",
        stats: "統計",
        search: "検索",
        config: {
            config: '設定',
            info: '情報',
            link: 'リンク',
            settings: '設定',
            thirdParty: 'サードパーティー設定',
            language: '言語',
            display: '表示',
            status: 'ステータス',
            quota: 'クォータ',
            baseInfo: '基本情報',
            projectName: 'プロジェクト名',
            projectDescription: 'プロジェクト説明',
            organization: '所属組織',
            save: '保存',
            linkSettings: 'リンク設定',
            surveyLink: 'アンケートリンク',
            shareLink: '共有リンク',
            copy: 'コピー',
            baseSettings: '基本設定',
            surveyStatus: 'アンケートステータス',
            on: 'オン',
            off: 'オフ',
            allowRepeat: '重複提出を許可',
            showProgress: '進捗バーを表示',
            thirdPartyIntegration: 'サードパーティー統合',
            wechat: 'WeChat統合',
            workWechat: 'エンタープライズWeChat',
            dingtalk: '釘釘',
            languageSettings: '言語設定',
            defaultLanguage: 'デフォルト言語',
            supportedLanguages: 'サポート言語',
            zhCN: '簡体中国語',
            enUS: 'English',
            displaySettings: '表示設定',
            themeColor: 'テーマカラー',
            fontSize: 'フォントサイズ',
            showLogo: 'ロゴを表示',
            projectStatus: 'プロジェクトステータス',
            currentStatus: '現在のステータス',
            startTime: '開始時間',
            endTime: '終了時間',
            quotaManage: 'クォータ管理',
            surveyLimit: 'アンケートクォータ',
            storageLimit: 'ストレージ容量',
            apiLimit: 'API呼び出し回数',
            unitMB: 'MB',
            linkCopied: 'リンクがクリップボードにコピーされました',
            saving: '設定が保存されました',
            ongoing: '進行中',
            finished: '完了',
            paused: '一時停止',
            deleted: '削除済み',
        },
        responses: "応答",
        views: "閲覧",
        completion: "完了率",
        emptyTip: "データなし",
        emptyCreate: "プロジェクトを作成",
        deleteSuccess: "削除成功",
        deleteFail: "削除失敗",
        confirmDelete: "確認削除",
        confirmDeleteTip: "プロジェクト \"{name}\" を削除しますか？",
        createProject: {
            createProject: "プロジェクトを作成",
            selectType: 'プロジェクトタイプを選択',
            regular: '通常アンケート',
            regularDesc: '新しいアンケートプロジェクトをゼロから作成',
            template: 'テンプレートをインポート',
            templateDesc: '事前設定されたテンプレートから迅速にプロジェクトを作成',
            copy: 'プロジェクトをコピー',
            copyDesc: '既存のプロジェクトからコピーを作成',
            ai: 'AI解析',
            aiDesc: 'AIを使用してアンケート構造を自動生成',
            aiBadge: 'テスト版',
            downloadExcelTemplate: 'Excelファイル形式テンプレートをダウンロード',
            downloadJsonTemplate: 'JSONファイル形式テンプレートをダウンロード',
            uploadTip: 'ファイルをここにドラッグするか、',
            clickUpload: 'クリックしてアップロード',
            uploadNotice: '注意：excel、jsonファイルをアップロードしてください。迅速にプロジェクトを作成します',
            searchProject: 'プロジェクトを検索',
            search: '検索',
            keepLogic: 'ロジックを保持',
            keepScript: 'スクリプトを保持',
            createTime: '作成時間：',
            questionCount: '問題数：',
            aiPlaceholder: '作成したいアンケート内容の説明を入力してください。例：従業員満足度調査アンケートを作成し、作業環境、給与、職業発展などの問題を含めます',
            aiStart: '解析を開始',
            aiClear: 'クリア',
            aiTip1: 'AIはあなたの説明に基づいて自動的にアンケート構造を生成します',
            aiTip2: '説明が詳細なほど、生成されるアンケート構造が正確になります',
            info: 'プロジェクト情報',
            name: 'プロジェクト名',
            namePlaceholder: 'プロジェクト名を入力してください',
            organization: '所属組織',
            organizationPlaceholder: '所属組織を入力してください',
            description: 'プロジェクト説明',
            descriptionPlaceholder: 'プロジェクト説明を入力してください',
            cancel: 'キャンセル',
            create: 'プロジェクトを作成',
            uploadTemplate: 'テンプレートファイルをアップロードしてください',
            selectCopyProject: 'コピーするプロジェクトを選択してください',
            aiInputRequired: 'AI解析内容の説明を入力してください',
            aiParseRequired: 'AI解析を先に実行してください',
            createSuccess: 'プロジェクトが作成されました',
            createFail: 'プロジェクト作成失敗',
            createFailRetry: 'プロジェクト作成失敗、しばらく後に再試行してください',
        },
    },
    recycle: {
        title: "リサイクルセンター",
        id: "プロジェクトID",
        name: "プロジェクト名",
        deletedAt: "削除日時",
        createdAt: "作成日時",
        creator: "作成者",
        restore: "復元",
        noData: "データなし",
        confirmDelete: "確認削除",
        confirmDeleteTip: "このプロジェクトを完全に削除しますか？この操作は取り消せません。",
        restoreSuccess: "復元成功",
        restoreFail: "復元失敗",
        deleteSuccess: "削除成功",
        deleteFail: "削除失敗"
    },
    user: {
        title: "ユーザー管理",
        id: "ユーザーID",
        name: "ユーザー名",
        mobile: "ユーザー電話",
        email: "ユーザーEメール",
        avatar: "ユーザーアバター",
        confirmDelete: "ユーザーID「{id}」のデータ項目を削除しますか？",
        addTitle: "ユーザーを追加",
        editTitle: "ユーザー情報を編集",
        uploadAvatar: "アバターを変更",
        uploadSuccess: "アップロード成功！",
        uploadFail: "アップロード失敗: {msg}",
        uploadTypeError: "アバター画像はJPG/PNG形式のみです！",
        uploadSizeError: "アバター画像のサイズは2MBを超えてはいけません！",
        placeholderName: "ユーザー名を入力してください",
        placeholderMobile: "ユーザー電話を入力してください",
        placeholderEmail: "ユーザーEメールを入力してください",
        placeholderAvatar: "ユーザーアバターリンクを入力してください"
    },
    role: {
        title: "ロール管理",
        id: "ロール番号",
        name: "ロール名",
        key: "権限文字",
        sort: "表示順序",
        status: "ステータス",
        createTime: "作成日時",
        remark: "備考",
        menuPerm: "メニュー権限",
        dataPerm: "データ権限",
        assignUser: "ユーザーを割り当て",
        more: "もっと",
        confirmDelete: "ロール番号「{id}」のデータ項目を削除しますか？",
        addTitle: "ロールを追加",
        editTitle: "ロールを編集",
        dataScope: "権限範囲",
        allData: "すべてのデータ権限",
        customData: "カスタムデータ権限",
        deptData: "本部門データ権限",
        deptBelowData: "本部門及以下データ権限",
        selfData: "本人のデータ権限",
        selectAll: "すべて選択/すべて選択解除",
        parentLink: "親子連携",
        loading: "読み込み中、しばらくお待ちください",
        remarkPlaceholder: "内容を入力してください",
        successAdd: "追加成功",
        successEdit: "編集成功",
        successDelete: "削除成功",
        successStatus: "{action}成功",
        confirmStatus: "「{name}」ロールを{action}しますか？",
        assignDataPerm: "データ権限を割り当て",
        assignUserTitle: "ユーザーを割り当て",
        cancelAuth: "認証を取り消す",
        batchCancelAuth: "一括認証を取り消す",
        closePage: "閉じる",
        selectUser: "ユーザーを選択",
        selectUserTip: "割り当てるユーザーを選択してください",
        selectUserSuccess: "割り当て成功"
    },
    menu: {
        title: "メニュー管理",
        name: "メニュー名",
        icon: "アイコン",
        sort: "ソート",
        perms: "権限識別子",
        component: "コンポーネントパス",
        status: "ステータス",
        createTime: "作成日時",
        confirmDelete: "メニュー名「{name}」のデータ項目を削除しますか？",
        addTitle: "メニューを追加",
        editTitle: "メニューを編集",
        successAdd: "追加成功",
        successEdit: "編集成功",
        successDelete: "削除成功",
        placeholderName: "メニュー名を入力してください",
        placeholderRouteName: "ルート名を入力してください",
        placeholderPath: "ルートアドレスを入力してください",
        placeholderComponent: "コンポーネントパスを入力してください",
        placeholderPerms: "権限識別子を入力してください",
        placeholderQuery: "ルートパラメータを入力してください",
        placeholderIcon: "アイコンを選択",
        placeholderParentMenu: "親メニューを選択",
        parentMenu: "親メニュー",
        menuType: "メニュータイプ",
        directory: "ディレクトリ",
        menu: "メニュー",
        button: "ボタン",
        menuIcon: "メニューアイコン",
        displaySort: "表示ソート",
        routeName: "ルート名",
        routeNameTip: "デフォルトではルートアドレスと同じです：例えば、アドレスが`user`の場合、名前は`User`（特別な場合は名前をカスタマイズして、一意性を保証してください）",
        isExternalLink: "外部リンク",
        externalLinkTip: "外部リンクを選択すると、ルートアドレスは`http(s)://`で始まる必要があります",
        routeAddress: "ルートアドレス",
        routeAddressTip: "アクセスするルートアドレス、例：`user`、外部ネットワークアクセスの場合は`http(s)://`で始まる必要があります",
        componentPath: "コンポーネントパス",
        componentPathTip: "アクセスするコンポーネントパス、例：`system/user/index`、デフォルトでは`views`ディレクトリにあります",
        permissionChar: "権限文字",
        permissionCharTip: "コントローラーで定義された権限文字、例：@PreAuthorize(`@ss.hasPermi('system:user:list')`)",
        routeParams: "ルートパラメータ",
        routeParamsTip: "アクセスするルートのデフォルトパラメータ、例：`{\"id\": 1, \"name\": \"ry\"}`",
        displayStatus: "表示ステータス",
        displayStatusTip: "非表示にすると、サイドバーに表示されませんが、アクセスは可能です",
        menuStatus: "メニューステータス",
        menuStatusTip: "非アクティブにすると、サイドバーに表示されず、アクセスもできません",
        yes: "はい",
        no: "いいえ",
        mainCategory: "メインカテゴリ",
        nameRequired: "メニュー名を入力してください",
        sortRequired: "メニュー順序を入力してください",
        pathRequired: "ルートアドレスを入力してください"
    },
    header: {
        lang: {
            zh: '簡体中国語',
            zh_TW: '繁体中国語',
            en: 'English',
            jp: '日本語',
            ko: '韓国語',
            id: 'インドネシア語',
        },
        helpDoc: 'ヘルプドキュメント'
    },
    questionEdit: {
        readonlyLocked: 'このプロジェクトは閲覧のみのため、内容は変更できません',
        // 題型名
        sortQuestion: '順序題',
        singleQuestion: '単一選択題',
        multiQuestion: '複数選択題',
        numberQuestion: '数値題',
        textQuestion: 'テキスト題',
        dateQuestion: '日付題',
        timeQuestion: '時間題',
        uploadQuestion: 'アップロード題',
        scoreQuestion: 'スコア題',
        openQuestion: 'オープン質問',
        timestampQuestion: 'タイムスタンプ',
        selectQuestion: '選択題',
        cascadeLevelLabel: '第{level}レベルオプション',
        cascadeOptionsManagement: 'カスケードオプション管理',
        placeholderHint: 'プレースホルダー: ',
        placeholderInput: '第{level}レベルのプレースホルダーを入力してください',
        manageOptions: 'オプション管理',
        manageSubOptions: 'サブオプション管理',
        subOptionNamePlaceholder: 'サブオプション名を入力してください',
        optionTextLabel: 'オプションテキスト',
        optionCodeLabel: 'オプションコード',
        optionTextPlaceholder: 'オプションテキストを入力してください',
        optionCodePlaceholder: 'オプションコードを入力してください',
        optionCodeDuplicate: '第{level}レベルに重複したオプションコードがあります',
        optionCodeDuplicateGlobal: '重複したオプションコードがあります。修正してから保存してください',
        optionValueDuplicate: 'この問題ではオプション値を重複できません',
        publishOptionCodeDuplicate: '以下の問題に重複したオプションコードがあります: {questions}. 修正してから公開してください',
        matrixSingleQuestion: '行列単一選択題',
        matrixMultiQuestion: '行列複数選択題',
        matrixBlankQuestion: '行列空白題',
        matrixCompositionQuestion: '行列複合題',
        matrix: {
            exportOrientation: '主方向',
            perRow: '行',
            perCol: '列',
            exclusiveLabel: '上記のいずれでもない',
            exclusiveNone: 'オフ',
            exclusiveRow: '行のみ',
            exclusiveCol: '列のみ',
            exclusiveBoth: '行+列',
            transposeStructure: '設問構造の転置',
            total: '合計'
        },
        thermodynamicChartQuestion: '熱力学グラフ題',
        combinationQuestion: '組合問題',
        
        // 特殊題型
        specialComponents: '特殊問題',
        loopQuestion: 'ループ問題',

        // 共通操作
        delete: '削除',
        clear: 'クリア',
        addOption: 'オプションを追加',
        batchAdd: '一括追加',
        batchAddTitle: 'オプションを一括追加',
        batchAddHint: '1行に1つのオプション。Excel から2列を貼り付けると数値列が選択値として自動認識され、タブがない場合は「1 オプション文言」のような空白区切りにも対応します。認識結果は下でプレビューし、ドラッグで最終順序を調整できます。',
        batchAddPlaceholder: '1\tオプションA\n2\tオプションB\n3\tオプションC',
        batchAddParsedCount: '{count} 件のオプションを認識しました',
        batchAddPreviewTitle: '追加後の最終順序',
        batchAddPreviewEmpty: '内容を貼り付けると、追加後のオプション一覧が表示されます',
        batchAddTagNew: '新規',
        batchAddDragTip: '行全体をドラッグして並び替え可能。値とオプション文言はそのまま編集できます',
        batchAddValueTaken: '値 {input} は同じ設問の別オプションで使用済みのため、{value} に変更しました',
        batchAddValueInvalid: '値 {input} は有効な正の整数ではないため、{value} に変更しました',
        batchAddValueAdjustedTip: '{count} 件のオプションの値が重複または不正だったため、未使用の値に変更しました。行の黄色いアイコンにカーソルを合わせると理由が表示され、任意の値に直接変更もできます。',
        batchAddRowErrorSummary: '{count} 行を修正すると確定できます',
        batchAddRichHint: 'このオプションにはリッチテキスト書式が含まれます。ここでは平文のみ表示し、変更しなければ元の書式を保持します',
        batchAddWhitespaceHint: 'このオプション文言は前後に空白を含み、そのまま保持して回答画面にも表示されます',
        batchAddModeTab: 'タブで分割',
        batchAddModeSpace: '空白で分割',
        batchAddModeTextOnly: '行全体をオプション文言に',
        batchAddSuccess: '{count} 件のオプションを追加しました',
        batchAddExistingCount: '既存 {count} 件',
        batchAddRemoveExisting: '既存の選択肢を削除',
        batchAddRemoveExistingHint: '既存の選択肢をまとめて削除し、今回貼り付けたものだけを残します',
        batchAddRestoreRemoved: '{count} 件を復元',
        batchAddRestoreRemovedHint: '削除した既存の選択肢を元の位置に戻します',
        batchAddRemoveRowHint: 'この項目を削除（既存の選択肢も削除できます）',
        batchAddPreviewEmptyAfterRemove: '既存の選択肢 {count} 件をすべて削除しました。新しい選択肢を貼り付けるか、上の「復元」で戻せます',
        batchAddNeedOneOption: 'プレビューには少なくとも 1 件の選択肢が必要です',
        batchAddSuccessMixed: '{added} 件追加、{removed} 件削除しました',
        batchDelete: '一括削除',
        batchSelectAll: 'すべて選択',
        batchSelectOption: 'このオプションを選択',
        batchSelectedCount: '{count} 件選択中',
        batchDeleteSelected: '選択項目を削除',
        batchDeleteConfirmMessage: '選択した {count} 件のオプションを削除しますか？削除後は「取り消し」で復元できます。',
        batchDeleteSuccess: '{count} 件のオプションを削除しました',
        batchSelectAllRows: '行をすべて選択',
        batchSelectAllCols: '列をすべて選択',
        batchSelectRow: 'この行を選択',
        batchSelectColumn: 'この列を選択',
        batchSelectedMatrixCount: '{rows} 行 · {cols} 列を選択中',
        batchDeleteConfirmMatrix: '選択した {rows} 行、{cols} 列を削除しますか？削除後は「取り消し」で復元できます。',
        batchDeleteSuccessMatrix: '{rows} 行、{cols} 列を削除しました',
        clearConfirmCount: '全 {count} 問',
        loadingMoreQuestions: '後続の質問を読み込んでいます…',
        loadedProgress: '{loaded}/{total} 問を読み込みました。クリックでさらに読み込みます',
        richText: 'リッチテキスト',
        confirm: '確定',
        cancel: 'キャンセル',

        // プレースホルダー
        optionPlaceholder: 'オプションを入力してください',
        numberPlaceholder: '数値を入力してください',
        textPlaceholder: 'テキストを入力してください',
        datePlaceholder: '日付を選択してください',
        timePlaceholder: '時間を選択してください',
        scorePlaceholder: 'スコアを入力してください',
        uploadPlaceholder: 'クリックしてアップロードするか、ここにファイルをドラッグしてください',
        dateFormat: '日付時間フォーマット',

        // design/index.vue テンプレート用の追加キー
        inputQuestionNo: '問題番号を入力',
        scriptType: 'スクリプトタイプ',
        tags: 'タグ',
        previewDialog: {
            devicePhone: 'スマホ',
            deviceTablet: 'タブレット',
            devicePc: 'PC'
        },

        // ヒントメッセージ
        saveSuccess: '保存成功',
        finishConfirmTitle: 'プロジェクトを終了に設定',
        finishConfirmMessage: 'プロジェクト状態を「終了」に設定すると、オンラインアンケートはロックされ、回答や編集ができなくなります。続行しますか？',
        finishConfirmButton: '保存してロック',
        saveFail: '保存失敗',
        deleteSuccess: '削除成功',
        deleteFail: '削除失敗',
        uploadSuccess: 'アップロード成功',
        uploadFail: 'アップロード失敗',
        emptyOptionError: 'オプション内容を入力してください',
        optionValueEmpty: 'オプション値は空または 0 にできません',
        optionEmptyReverted: 'オプション内容が空のため、元の内容に戻しました。削除する場合は右側の削除ボタンをご利用ください。',
        addQuestionSuccess: '問題を追加しました',
        undo: '元に戻す',
        undoSuccess: '直前の変更を元に戻しました',
        undoNoChange: '元に戻す変更がありません',
        undoFailed: '元に戻せませんでした。もう一度お試しください',
        switchLanguageSuccess: '言語切り替え成功',
        maxFilesExceeded: '最大で{max}個のファイルのみアップロードできます',
        fileSizeExceeded: 'ファイルサイズは{size}MBを超えてはいけません',

        // 編集関連
        newOption: '新しいオプション',
        editTitle: 'タイトルを編集',
        editOption: 'オプションを編集',
        deleteConfirm: '削除しますか？',
        deleteConfirmTitle: '削除の確認',
        titleMarkupLostTitle: 'タイトルに書式が含まれています',
        titleMarkupLostMessage: 'このタイトルにはリッチテキストの書式が含まれています。プレーンテキストで保存すると書式は失われます。続行しますか？（「リッチテキスト」をクリックすると書式を保持して編集できます）',
        addNoneOfAbove: '「以上いずれも該当しない」を追加',
        noneOfAbove: '以上いずれも該当しない',
        exclusiveTag: '単一選択',
        exclusiveTagTip: '単一選択：これを選ぶと他の選択肢は自動的に解除されます',
        exclusiveRemoveTip: 'クリックでルールを削除',
        exclusiveExists: '単一選択のルールは既にあります',
        exclusiveRemoveConfirm: 'この「単一選択」ルールを削除しますか？',
        exclusiveRemoved: '単一選択ルールを削除しました',
        exclusiveAdded: '単一選択ルールを追加しました',
        exclusiveLogicSaveFailed: '単一選択ルールの保存に失敗しました。「ロジック」タブで手動で追加してください。',

        // 回答の引用（前の設問の回答を題干に挿入）
        answerRef: {
            button: '回答を引用',
            buttonTip: '前の設問の回答を題干に挿入します',
            title: '前の設問の回答を引用',
            subtitle: '前の設問の回答を題干に挿入します。回答時に回答者の選択内容へ自動で置き換わります。',
            search: '設問番号またはタイトルを検索…',
            empty: '引用できる前の設問がありません',
            loading: '設問を読み込み中…',
            disabled: '未対応',
            disabledTip: 'この設問タイプはまだ引用できません',
            quickInsert: '挿入',
            modes: '引用方法',
            modeWhole: '設問全体の回答',
            modeWholeDesc: 'この設問の回答全体を引用します',
            modeOther: '「その他」の入力内容',
            modeOtherDesc: '「その他」に入力された文字だけを引用します',
            modeItem: '{n} 番目の項目',
            modeRow: '{n} 行目',
            modeCell: '{r} 行 {c} 列',
            modeItemTitle: 'N 番目に選択した項目',
            modeItemDesc: '多肢選択・並べ替えで選んだ N 番目の項目を引用します',
            modeRowTitle: '行',
            modeRowDesc: 'この行の回答を引用します',
            modeCellTitle: 'セル',
            modeCellDesc: 'このセルの回答を引用します',
            rowPick: '引用する行を選択',
            cellPick: '表のセルをクリックして選択',
            otherPick: 'どの「その他」かを選択',
            itemPick: '何番目かを選択',
            preview: '例',
            previewPrefix: 'プレビュー：',
            unanswered: '未回答時：{text}',
            unansweredSample: '[未回答]',
            insert: '題干に挿入',
            cancel: 'キャンセル',
            inserted: '引用済み',
            dragHint: 'タイトル内のチップを直接ドラッグして位置を調整',
            broken: '引用が無効です',
            removeRef: 'この引用を削除',
            brokenTip: 'この設問は削除されたか、番号が変更されました',
            noPreview: '左の設問を選択して内容を確認してください'
        },
        collapse: '折りたたみ',
        valueLabel: '値：',
        otherLabel: 'その他：',
        netLabel: 'グループ：',
        netNone: '-',
        netGroup: 'NETグループ',
        netGroupPlaceholder: 'グループ名を入力',

        // デフォルト値
        defaultTitle: '新しい問題',
        defaultOption: 'オプション{index}',
        
        //親コンポーネント
        // ===== 以下はdesign親コンポーネントtemplateに追加されたkey、重複も保持、後で微調整 =====
        edit: '編集',
        save: '保存',
        statistics: '統計',
        data: 'データ',
        download: 'ダウンロード',
        publish: '公開',
        projectFile: 'プロジェクトファイル',
        questionType: '問題タイプ',
        outline: 'アウトライン',
        searchAndJump: '問題を検索してジャンプ',
        refreshOutline: 'アウトラインを更新',
        order: '順序',
        orderImportExport: '問題番号順序のインポート/エクスポート',
        questionBank: '問題集',
        basicComponents: '基本コンポーネント',
        advancedComponents: '進階コンポーネント',
        myQuestionBank: '私の問題集',
        add: '追加',
        comprehensiveCustomerSatisfactionSurvey: '総合顧客満足度調査',
        publicQuestionBank: '公開問題集',
        standardQuestionBankGroup: '標準問題集グループ',
        standardTextQuestion: '標準テキスト問題',
        standardSingleChoiceQuestion: '標準単一選択問題',
        standardMultipleChoiceQuestion: '標準複数選択問題',
        standardOpenQuestion: '標準オープン質問',
        standardRatingQuestion: '標準スコア問題',
        specialQuestionBankGroup: '特殊問題集グループ',
        specialTextQuestion: '特殊テキスト問題',
        otherQuestionBankGroup: 'その他の問題集グループ',
        set: '設定',
        thenExecutionActions: 'THEN実行アクション',
        beforeExecution: '実行前',
        duringExecution: '実行中',
        afterExecution: '実行後',
        favoriteScript: 'お気に入りスクリプト',
        personal: '個人',
        details: '詳細',
        
        tabSetting: '設定',
        tabLogic: 'ロジック',
        tabScript: 'スクリプト',
        options: 'オプション',
        moreConfig: 'より多くの設定',
        lengthPx: '長さ (px)：',
        widthPercent: '幅 (%)：',
        minLength: '最小文字数：',
        maxLength: '最大文字数：',
        minNumber: '最小数値：',
        maxNumber: '最大数値：',
        allowChar: '文字：',
        allowNumber: '数値：',
        allowDecimal: '小数：',
        decimalPlaces: '小数点以下桁数：',
        fontSelect: 'フォントを選択',
        fontSize: 'フォントサイズ',
        optionSize: 'オプションサイズ',
        layoutDirection: 'レイアウト方向',
        horizontal: '水平',
        vertical: '垂直',
        rowCount: '行数',
        rowWidth: '行幅',
        colCount: '列数',
        colHeight: '列高',
        hideImage: '画像を非表示',
        operate: '操作',
        saveLogic: '保存ロジック',
        logicList: 'ロジックリスト',
        selectCondition: '条件を選択',
        selectOption: 'オプションを選択',
        inputValue: '値を入力してください',
        selectRelation: '関係を選択',
        priority: '優先度',
        selectAction: 'アクションを選択',
        inputText: 'テキストを入力してください',
        inputLink: 'リンクを入力してください',
        inputQuestionTitle: '新しい質問タイトルを入力してください',
        selectRowCol: '行/列を選択',
        row: '行',
        column: '列',
        selectRowOption: '行オプションを選択',
        selectColOption: '列オプションを選択',
        searchScript: 'スクリプトを検索',
        detail: '詳細',
        scriptEdit: 'スクリプト編集',
        scriptDetail: 'スクリプト詳細',
        search: '検索',
        questionNo: '問題番号',
        logicSettings: 'ロジック設定',
        refreshLogic: 'ロジックを更新',
        addLogic: 'ロジックを追加',
        ifConditionSettings: 'IF条件設定',
        favoriteScriptList: 'お気に入りスクリプトリスト',
        public: '公開',
        apply: '適用',
        saveScript: 'スクリプトを保存',
        optionContent: 'オプション内容',
        tabMoreSetting: '設定',
        tabMoreDisplay: '表示',
        tabMoreImage: '画像',
        fontMicrosoftYaHei: 'マイクロソフト・ヤフー',
        fontSimSun: '宋体',
        fontSimHei: '黒体',
        fontArial: 'Arial',
        Statistics: {
            dashboardTitle: 'データ分析ダッシュボード',
            effectiveCount: '有効回収量',
            totalCount: '総調査量',
            recoveryRate: '回収率',
            avgTime: '平均完了時間',
            deviceModel: 'デバイスモデル',
            dailyTrend: '日別収集トレンド',
            respondentLocation: '回答者属地分布',
            briefRecordList: '簡易記録リスト',
            projectId: 'プロジェクトID',
            ipAddress: 'IPアドレス',
            deviceType: 'デバイスモデル',
            time: '時間',
            duration: '所要時間',
            singleChoiceTitle: '単一選択題回答分布',
            singleChoiceOption: 'オプション分布',
            multipleChoiceTitle: '複数選択題回答分布',
            multipleChoicePeople: '選択人数',
            optionA: 'オプションA',
            optionB: 'オプションB',
            optionC: 'オプションC',
            optionD: 'オプションD',
            china: '中国',
            usa: 'アメリカ',
            europe: 'ヨーロッパ',
            asiaOther: 'アジアその他',
            other: 'その他',
            ios: 'iOS',
            android: 'Android',
            windows: 'Windows',
            mac: 'Mac',
        },
        dataView: {
            listTitle: '回答記録',
            id: 'ID',
            projectId: 'プロジェクトID',
            version: 'バージョン',
            linkType: 'リンクタイプ',
            status: 'ステータス',
            startTime: '回答開始時間',
            endTime: '回答終了時間',
            createTime: '回答終了時間',
            duration: '回答所要時間',
            ipAddress: 'IPアドレス',
            deviceType: 'デバイスモデル',
            device: '具体的デバイス',
            actions: '操作',
            edit: '編集',
            details: '詳細',
            editAnswer: '回答を編集',
            cancel: 'キャンセル',
            save: '保存',
        },
        downloadView: {
            exportOptions: 'エクスポートオプション',
            exportOptionsSubtitle: 'エクスポート形式とオプションを選択',
            fileFormat: 'ファイル形式',
            exportOptionsTitle: 'エクスポートオプション',
            dateRange: '日付範囲',
            startDatePlaceholder: '開始日',
            endDatePlaceholder: '終了日',
            startExport: 'エクスポートを開始',
            excel: 'Excel',
            excelDesc: 'データ分析と処理に適しています',
            csv: 'CSV',
            csvDesc: '汎用形式、すべてのデバイスで使用可能',
            pdf: 'PDF',
            pdfDesc: '印刷と共有に適しています',
            json: 'JSON',
            jsonDesc: '開発者とシステム統合に適しています',
            spss: 'SPSS',
            spssDesc: '統計分析ソフトウェアに適しています',
            audio: '音声',
            audioDesc: 'すべての録音ファイルを一括ダウンロード',
            image: '画像',
            imageDesc: 'アップロード問題のファイルを一括ダウンロード',
            includeAnswerTime: '回答時間を含める',
            includeDeviceInfo: 'デバイス情報を含める',
            includeIpAddress: 'IPアドレスを含める',
            includeLocation: '位置情報を含める',
            includeUserId: 'ユーザーIDを含める',
            includeAnswerType: '回答タイプを含める',
            includeQuestionAnswers: '質問回答を含める',
            exportImageAnswer: '画像回答をエクスポート',
            exportFail: 'エクスポートに失敗しました',
            spssExportTypeError: 'SPSS エクスポート失敗 (予期しない戻り値の型)',
            spssExportEmptyFile: 'SPSS エクスポート失敗 (ファイルが空です)',
            spssExportFail: 'SPSS エクスポート失敗',
            surveyStatus: 'アンケートステータス',
            statusAll: 'すべて',
            statusAnswered: '完了',
            compositeSplit: '複合問題の分割',
            dataMode: 'データ形式',
            code: 'Code',
            label: 'Label',
            comingSoon: '開発中の機能、お楽しみに',
        },
        publishProject: {
            title: 'プロジェクトを公開',
            historyLink: '履歴リンク',
            generateLink: 'リンクを生成',
            moreLinks: 'その他のリンク',
            linkGenerator: 'アンケートリンク生成器',
            fixedLink: '固定リンク生成',
            prod1: '正式リンク1',
            prod1Tip: 'GUIDとIP制御付き',
            prod2: '正式リンク2',
            prod2Tip: 'アンケートID制御',
            test: 'テストリンク',
            testTip: 'ナビゲーションバー、前の問題ボタンを表示',
            ipCtrlDeveloping: 'IP制御機能はまだ開発中です',
            breakpointAutoCheckedTip: '{source}を有効にすると、回答中断点制御が自動的にチェックされます',
            breakpointControlledTip: '回答中断点制御は単独でチェックできません。GUID制御またはアンケートIDを先に有効にしてください',
            offline: 'オフラインリンク',
            offlineTip: 'オフラインリンク',
            custom: 'カスタムリンク',
            customTip: 'カスタムリンク',
            customLink: 'カスタムリンク生成',
            accessControl: 'アクセス制御',
            ipCtrl: 'IP制御',
            guidCtrl: 'GUID制御',
            surveyIdCtrl: 'アンケートID制御',
            breakpointCtrl: '回答ブレークポイント制御',
            externalIdCtrl: '外部識別子ブレークポイント',
            displayOptions: '表示オプション',
            showNav: 'ナビゲーションバーを表示',
            showPrev: '前の問題ボタンを表示',
            offlineSubmit: 'オフラインリンク別重複回答',
            createLink: 'リンクを作成',
            generatedLink: '生成されたリンク',
            placeholder: 'リンクを作成する前にクリックしてください',
            copy: 'コピー',
            copySuccess: 'リンクがクリップボードにコピーされました',
            generateSuccess: 'リンクが生成されました！',
            generateFail: '生成失敗',
            history: '履歴リンク',
            all: 'すべて',
            prod: '正式',
            testCategory: 'テスト',
            id: '番号',
            link: 'リンク',
            category: 'カテゴリ',
            type: 'タイプ',
            createTime: '作成日時',
            disabled: '無効化',
            yes: 'はい',
            no: 'いいえ',
            version: 'バージョン',
            tags: 'タグ',
            // 終了状態の公開をブロック
            finishBlockedTitle: '公開できません',
            finishBlockedMessage: 'アンケートは終了しています。公開するには状態を調整してください。',
            finishBlockedButton: '了解'
        },
        resourceManagement: {
            resourceManagement: 'リソース管理',
            title: 'リソース管理',
            upload: 'リソースをアップロード',
            searchPlaceholder: 'リソースを検索',
            id: 'ID',
            name: 'リソース名',
            projectId: 'プロジェクトID',
            createTime: '作成日時',
            url: 'リソースリンク',
            actions: '操作',
            copyLink: 'リンクをコピー',
            delete: '削除',
            confirmDelete: 'このリソースを削除しますか？',
            confirm: 'ヒント',
            deleteSuccess: '削除成功',
            deleteFail: '削除失敗',
            copySuccess: 'リンクがクリップボードにコピーされました',
            fetchFail: 'リソースリストの取得に失敗しました',
            pageTotal: '合計 {total} 件',
        },
        resourceUpload: {
            title: 'リソースをアップロード',
            name: 'リソース名',
            namePlaceholder: 'リソース名を入力してください',
            file: 'リソース添付ファイル',
            uploadText: 'ファイルをここにドラッグするか、',
            clickUpload: 'クリックしてアップロード',
            uploadTip: '注意：サイズは100MB（jpg、png、pdf、doc、docx、xls、xlsx形式をサポート）',
            cancel: 'キャンセル',
            confirm: '確認',
            fileTypeError: 'ファイル形式がサポートされていません',
            fileSizeError: 'ファイルサイズは100MBを超えてはいけません',
            nameRequired: 'リソース名を入力してください',
            fileRequired: 'アップロードするファイルを選択してください',
            uploadSuccess: 'アップロード成功',
            uploadFail: 'アップロード失敗',
            deleteFail: 'リソース削除失敗、しばらく後に再試行してください',
        },
    },
    profileView: {
        title: '個人情報',
        back: '戻る',
        edit: '編集',
        save: '保存',
        cancel: 'キャンセル',
        username: 'ユーザー名',
        avatar: 'アバター',
        changeAvatar: 'アバターを変更',
        email: 'メール',
        phone: '電話番号',
        usernameRequired: 'ユーザー名を入力してください',
        usernameLength: '文字数は3から20文字です',
        emailRequired: 'メールアドレスを入力してください',
        emailFormat: '正しいメールアドレスを入力してください',
        phoneRequired: '電話番号を入力してください',
        phoneFormat: '正しい電話番号を入力してください',
        saveSuccess: '保存成功',
        saveFail: '保存失敗',
        avatarTypeError: 'アバター画像はJPG形式のみです！',
        avatarSizeError: 'アバター画像のサイズは2MBを超えてはいけません！',
    },
    notFound: {
        title: '404',
        pageNotFound: 'ページが見つかりません',
        searching: 'お探しのページを探しています...',
        backHome: 'ホームに戻る',
    },
    iconSelect: {
        placeholder: 'アイコン名を入力してください',
    },
    tinymce: {
        placeholder: 'ここにテキストを入力してください',
    },
    brands: {
        common: {
            all: 'すべて',
            id: 'ID',
            actions: '操作',
            search: '検索',
            reset: 'リセット',
            refresh: '更新',
            edit: '編集',
            delete: '削除',
            save: '保存',
            cancel: 'キャンセル',
            tip: 'ヒント',
            saveFail: '保存失敗',
            deleteFail: '削除失敗'
        },
        category: {
            title: 'ブランド分類',
            create: '分類追加',
            listTitle: '分類一覧',
            onlyTop: '一级のみ表示',
            searchPlaceholder: '分類名を検索',
            parentPlaceholder: '一级分類',
            childPlaceholder: '二級分類',
            level1: '一级',
            level2: '二級',
            columns: {
                name: '分類名',
                level: '階層',
                parent: '親分類'
            },
            createTitle: '分類追加',
            editTitle: '分類編集',
            deleteConfirmMessage: 'この分類を削除しますか？',
            form: {
                name: '分類名',
                level: '階層',
                parent: '親分類',
                levelPlaceholder: '階層を選択してください',
                parentPlaceholder: '二級分類は親分類が必要です',
                nameRequired: '分類名を入力してください',
                levelRequired: '階層を選択してください',
                parentRequired: '二級分類は親分類が必要です'
            }
        }
    },
    request: {
        kickedOut: 'アカウントが別の場所でログインされたため、このセッションはログアウトされました。心当たりがない場合は、すぐにパスワードを変更してください。',
        badRequest: 'リクエストの内容に誤りがあります。入力をご確認ください',
        forbidden: 'この操作を実行する権限がありません',
        notFound: 'リクエストされた内容が存在しないか、削除されています',
        timeout: 'リクエストがタイムアウトしました。通信環境をご確認のうえ再試行してください',
        payloadTooLarge: 'アップロードする内容が大きすぎます。圧縮して再試行してください',
        tooManyRequests: '操作が頻繁すぎます。しばらくしてからお試しください',
        serverError: 'サーバーでの処理に失敗しました。しばらくしてからお試しください',
        serviceUnavailable: 'サービスが一時的に利用できません。しばらくしてからお試しください',
        failedWithStatus: 'リクエストに失敗しました（{status}）。しばらくしてからお試しください',
        networkError: '通信エラーが発生しました。通信環境をご確認のうえ再試行してください'
    }
}
